export default [
    {
        name: 'Home',
        icon: 'fa fa-home',
        path: '/main'
    },
    {
        name: 'Dashboard',
        icon: 'fas fa-chart-bar',
        path: '/reporting',
        meta: ['rd', 'td', 'missionary', 'affiliate', 'ad', 'pd', 'chaplain',
            'parish-td', 'parish-missionary']
    },
    {
        name: 'Bible Studies',
        icon: 'fa fa-book',
        path: '/bible-studies'
    },
    {
        name: 'Bible Study Reporting',
        icon: 'fa fa-percent',
        path: '/reporting-percentages',
        meta: ['rd', 'td', 'missionary', 'affiliate', 'ad', 'pd', 'chaplain']
    },
    {
        name: 'Discipleship Groups',
        icon: 'fa fa-sitemap',
        path: '/discipleship-groups',
        meta: ['parish-td', 'parish-missionary', 'ad', 'rd'],
        roleFunction: 'parishOnly'
    },
    {
        name: 'Discipleship',
        icon: 'fa fa-sitemap',
        path: '/discipleship',
        meta: ['rd', 'td', 'missionary', 'affiliate', 'ad', 'pd', 'chaplain', 'student',
            'parish-td', 'parish-missionary']
    },
    {
        name: 'People',
        icon: 'fa fa-users',
        path: '/people',
    },
    {
        name: 'Invitations',
        icon: 'fas fa-dove',
        path: '/invitations',
    },
    {
        name: 'Depth Chart',
        icon: 'fas fa-praying-hands',
        path: '/depth-chart',
    },
    {
        name: 'Recruitment',
        icon: 'fas fa-handshake',
        path: '/recruitment-depth-chart',
        meta: ['pd', 'ad', 'rd', 'td', 'missionary', 'affiliate']
    },
    {
        name: 'Plan a Bible Study',
        icon: 'fa fa-pencil-square-o',
        path: '/bible-study-plans',
    },
    {
        name: 'Pray Meditations',
        icon: 'nc-icon nc-sun-fog-29',
        path: '/meditations',
    },
    {
        name: 'Admin locations',
        icon: 'fa fa-map-marker',
        path: '/locations',
        meta: ['admins']
    },
    {
        name: 'Admin delegations',
        icon: 'fas fa-user-plus',
        path: '/delegations',
        meta: ['admins']
    },
];
